import React from 'react'

export interface ThresholdClasses {
	[threshold: number]: string
}

export type ProgressType = 'inc' | 'dec'

export type ThresholdType = 'percent' | 'value'

export interface ProgressBarProps {
	progress: number
	total?: number
	progressType: ProgressType
	thresholdClasses: ThresholdClasses
	thresholdType?: ThresholdType
}

export function ProgressBar(props: ProgressBarProps) {
	let total = props.total || 100
	let thresholdType = props.thresholdType || 'percent'

	let percentProgress = props.progress / total * 100

	let className = 'progress '

	let thresholdValues = Object.keys(props.thresholdClasses)
		.map(Number.parseFloat)
		.sort((a, b) => {
			let comparison = a > b ? -1 : a < b ? 1 : 0
			if (props.progressType == 'dec') comparison *= -1
			return comparison
	})

	const progress = thresholdType == 'value' ? props.progress : percentProgress

	for (const thresholdValue of thresholdValues) {
		if (props.progressType == 'inc' && progress >= thresholdValue || props.progressType == 'dec' && progress <= thresholdValue ) {
			className += props.thresholdClasses[thresholdValue]
			break
		}
	}

	const percentProgressString = percentProgress.toFixed(2) + '%'

	return (
		<progress className={className} value={props.progress} max={total} title={percentProgressString}>percentProgressString</progress>
	)
}

export default ProgressBar